<div class="nv-dialog">
  <div class="dialog-head">
    <h2>{{ title }}</h2>
  </div>
  <div class="dialog-message">{{ message }}</div>
  <div class="dialog-controls">
    <nv-button (click)="onConfirm()">{{ confirmText }}</nv-button>
  </div>
</div>
